import { TextType } from './types';

export const AVATAR_TEXT_TYPE: Record<TextType, TextType> = {
  initials: 'initials',
  plain: 'plain',
};
